<template>
  <section class="auth-section">
    <div class="row no-gutters h-100">
      <div class="col-lg-5">
        <AuthLeftPart/>
      </div>
      <div class="col-lg-6">
        <div class="right-part h-100 d-flex justify-content-center align-items-center">
          <div class="right__content">
            <h1 class="mb-3">{{ $t('change_password') }}</h1>
            <p v-if="mustChangePassword" class="auth__note mt-3 mb-4">{{ $t('must_change_password_notice') }}</p>
            <div v-if="showCurrentPassword">
              <InputGroup :label="$t('old_password')"
                          type="password"
                          autocomplete="current-password"
                          @enter="submit()"
                          v-model="form.current_password"/>
              <ValidationError validation-id="current_password"/>
            </div>
            <InputGroup :label="$t('new_password')"
                        type="password"
                        autocomplete="new-password"
                        @enter="submit()"
                        v-model="form.new_password"/>
            <ValidationError validation-id="new_password"/>
            <InputGroup :label="$t('confirm_password')"
                        type="password"
                        autocomplete="new-password"
                        @enter="submit()"
                        v-model="form.new_password_confirmation">
              <div class="text-danger mt-1"
                   v-if="form.new_password && form.new_password_confirmation && form.new_password !== form.new_password_confirmation">
                {{ $t('passwords_do_not_match') }}
              </div>
            </InputGroup>
            <ValidationError validation-id="new_password_confirmation"/>
            <PasswordRequirementsChecklist :password="form.new_password" class="mb-3"/>
            <div class="form-group text-right mt-md-4 pt-3">
              <button @click="submit()"
                      :disabled="loading"
                      class="btn-themed login-btn">{{ $t('save') }}
              </button>
            </div>
            <div v-if="errors && errors.general" class="alert alert-danger py-2">
              {{ errors.general.join(', ') }}
            </div>
            <div class="text-center mt-3">
              <a href="#" @click.prevent="logout">{{ $t('logout') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup"
import ValidationError from "@/components/form/ValidationError"
import PasswordRequirementsChecklist from "@/components/parts/staff/PasswordRequirementsChecklist.vue"
import AuthLeftPart from "@/components/parts/auth/AuthLeftPart.vue"
import { useStore } from "vuex"
import { useRouter } from "vue-router"
import {computed, onMounted, reactive, ref} from "vue"

const store = useStore()
const router = useRouter()
const showCurrentPassword = ref(true)

const form = reactive({
  current_password: "",
  new_password: "",
  new_password_confirmation: "",
})

onMounted(() => {
  store.commit('setError', {})
  if(store.state.auth.pendingCurrentPassword) {
    form.current_password = store.state.auth.pendingCurrentPassword
    store.commit('setPendingCurrentPassword', null)
    showCurrentPassword.value = false
  }
})

const loading = computed(() => store.state.dom.loading)
const errors = computed(() => store.state.auth.errors)
const mustChangePassword = computed(() => store.state.auth.mustChangePassword)

const submit = async () => {
  if(form.new_password !== form.new_password_confirmation) return
  try {
    await store.dispatch('changePassword', form)
    router.push('/')
  } catch (error) {
    console.error('Change password error:', error)
  }
}

const logout = async () => {
  await store.dispatch('logout')
  router.push('/login')
}
</script>

<style lang="scss" scoped>
.login-btn {
  min-width: 200px;
  width: 100%;
}
</style>
